import cls from 'classnames'
import React from 'react'
import { useRouteMatch } from 'react-router-dom'

import { useAppStateQuery } from '@/generated/graphql'
import { KnowledgeSidebar } from '@/modules/knowledge/knowledge-sidebar.component'
import { NotificationList } from '@/modules/notification/notification-list.component'
// import { SearchInput } from '@/modules/search'
import { routes } from '@/routes'

import s from './aside.module.less'
import { AsideAdminComponent } from './aside-admin.component'
import { AsideBar } from './aside-bar.component'
import { AsideHomeComponent } from './aside-home.component'
import { AsidePrioritiesComponent } from './aside-priorities.component'

export const AsideContainer = () => {
  const { data: appStateData } = useAppStateQuery()
  const matchMenu = useRouteMatch(routes.menu())
  const isPage = !!matchMenu

  const matchNotification = useRouteMatch({
    path: routes.notifications.home(),
    exact: false,
  })

  const matchLibrary = useRouteMatch({
    path: routes.knowledgebase.home(),
    exact: false,
  })

  let asideRight = (
    <div className={s.menu} style={{ marginTop: 20 }}>
      {/* <SearchInput> */}
      <>
        <AsideHomeComponent />
        <AsidePrioritiesComponent />
        <AsideAdminComponent />
      </>
      {/* </SearchInput> */}
    </div>
  )

  if (matchNotification) {
    asideRight = <NotificationList />
  }

  if (matchLibrary) {
    asideRight = <KnowledgeSidebar />
  }

  const rightContainer = appStateData!.appState.showSidebar && <div className={s.asideContainer}>{asideRight}</div>

  return (
    <aside
      className={cls(s.aside, {
        [s.isPage]: isPage,
      })}
    >
      <AsideBar />
      {rightContainer}
    </aside>
  )
}
